<template>
  <div class="o-tooltip o-tooltip--left"
       :class="tooltipAlignment">
    <button
      type="button"
      class="o-tooltip__icon"
      aria-describedby="tooltip"
      aria-controls="tooltip"
    >
      <span class="c-elipse">?</span>
      <span class="visually-hidden">Show description</span>
    </button>
    <div
      id="tooltip"
      :class="arrowClass"
      class="o-tooltip__description"
      role="tooltip"
    >
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  name: "Eclipse",
  props: {
    text: { type: String, required: true },
    disableArrow: { type: Boolean, required: false, default: false },
    tooltipBottom: { type: Boolean, required: false, default: false },
  },
  computed: {
    arrowClass() {
      return this.disableArrow ? "" : "o-tooltip--arrow-bottom";
    },
    tooltipAlignment() {
      return this.tooltipBottom ? "o-tooltip--bottom" : "o-tooltip--top";
    },
  },
};
</script>
